import { QUALIFICATION_CODES } from '../../../shared/constants/qualification-code';
import { SelectedQuota } from '../../../shared/interfaces/qualification.interface';

export class DistributionQuotaRule {
  constructor(
    public readonly qualification_code: number,
    public readonly quotas: SelectedQuota[]
  ) {}

  allow(): boolean {
    const specialCase = [
      QUALIFICATION_CODES.AGE,
      QUALIFICATION_CODES.INCOME,
      QUALIFICATION_CODES.CHILDREN,
      QUALIFICATION_CODES.CHILD_AGE_GENDER,
    ].includes(this.qualification_code);

    if (specialCase) {
      return this._selected().length >= 2;
    }

    return true;
  }

  private _selected(): SelectedQuota[] {
    return this.quotas.filter(
      (quota) =>
        quota.percentage != undefined &&
        quota.percentage !== null &&
        quota.percentage !== 0
    );
  }
}
